import React from 'react';

import { FormikCheckbox } from '~commonInfra/components/FormikCheckbox';
import { MetadataDrivenSiteSettings } from '~src/commonInfra/components/MetadataDrivenSiteSetting';
import { FeatureFlags } from '~src/commonInfra/featureFlags/FeatureFlags';
import { getSessionManagementServiceInstance } from '~src/sessionManagement/SessionManagementService';

import { Messages } from '../../../../../codegen/Localize';
import { SettingsSection } from '../../../../components/common/SettingsSection';
import { groupNameMessage } from '../../../../styles/CommonStyles';
import { componentRegistryEntry } from '../../SettingsComponentRegistryFunctions';
import { SiteSettingsForSiteAdminProps } from '../../site-settings/ReactSiteSettingsForSiteAdmin';
import { forceUncheckedIfUserVisibilityLimited, useUserVisibilityLimited } from '../user-visibility/UserVisibilitySection';

export const SHARING_ENABLED_FIELD = 'settings.siteNamedSharingSettings.namedSharingEnabled';
export const SHARING_SECTION_NAME = 'namedSharingEnabled';
export const SHARING_PREFIX = 'settings.siteNamedSharingSettings';

export type SharingSectionProps = SiteSettingsForSiteAdminProps<'siteNamedSharingSettings' | 'userVisibility'>;

export function SharingSection() {
  const isUserVisibilityLimited = useUserVisibilityLimited();
  const sessionManagementService = getSessionManagementServiceInstance();
  const sharingCheckboxLabel = sessionManagementService.isUserNotificationsPlatformEnabled() ?
    Messages.namedSharingCheckboxLabel() :
    Messages.namedSharingCheckboxLabelLegacy();

  const sharingDetails = sessionManagementService.isUserNotificationsPlatformEnabled() ?
    Messages.namedSharingDetails() :
    Messages.namedSharingDetailsLegacy();

  if (FeatureFlags.metadataDrivenSiteSettingsEnabled) {
    return (
    <SettingsSection
      title={Messages.namedSharingTitle()}
      testId={'sharing-setting-section'}>
        <MetadataDrivenSiteSettings
          sectionName={SHARING_SECTION_NAME}
          formikPrefix={SHARING_PREFIX} />
    </SettingsSection>
    );
  }

  return (
      <SettingsSection title={renderTitle(isUserVisibilityLimited)}
                       testId={'sharing-setting-section'}
                       description={sharingDetails}
                       disabled={isUserVisibilityLimited}>
        <FormikCheckbox
                        name={SHARING_ENABLED_FIELD}
                        label={sharingCheckboxLabel}
                        testId={'named-sharing'}
                        disabled={isUserVisibilityLimited}
                        {...forceUncheckedIfUserVisibilityLimited(isUserVisibilityLimited)}>
        </FormikCheckbox>
      </SettingsSection>
    );
}

function renderTitle(userVisibilityLimited: boolean) {
  return <>
    <div>{Messages.namedSharingTitle()}</div>
    {userVisibilityLimited &&
    <span className={groupNameMessage} data-tb-test-id={'named-sharing-uservisibility-warning'}>
      {Messages.userVisibilityWarning()}
    </span>}
  </>;
}

export const SharingSectionSpecs = componentRegistryEntry({
  name: 'SharingSection',
  component: SharingSection
});
